




















































/** reset() чистит поле браузера: иначе повторный выбор того же файла не даёт события change */
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class MmFileUpload extends Vue {
	@Prop({ default: null }) readonly value!: File | null;

	/** accept — подсказка диалогу, а не защита: расширение проверяет экран, эту проверку не убирать */
	@Prop({ default: '.xlsx,.xls,.csv' }) readonly accept!: string;

	@Prop({ default: false }) readonly disabled!: boolean;

	@Prop({ default: '' }) readonly disabledReason!: string;

	@Prop({ default: '' }) readonly placeholder!: string;

	@Prop({ default: '' }) readonly errorText!: string;

	/** Всегда пустой и всегда одна и та же ссылка: иначе ant начнёт копить выбранные файлы */
	private readonly antFileList: any[] = [];

	get hasError(): boolean {
		return this.errorText != null && String(this.errorText).trim() !== '';
	}

	get errorId(): string {
		return 'sm-mobilemon-file-error-' + String((this as any)._uid);
	}

	get fileName(): string {
		const file = this.value;

		return file && file.name ? String(file.name) : '';
	}

	get fileTitle(): string | null {
		if (this.disabled || this.fileName === '') {
			return null;
		}

		return this.fileName;
	}

	get canClear(): boolean {
		return !this.disabled && this.fileName !== '';
	}

	get placeholderText(): string {
		if (this.placeholder !== '') {
			return this.placeholder;
		}

		return this.$t('shared.messages.chooseFilePlaceholder') as string;
	}

	get browseText(): string {
		return this.$t('shared.actions.browse') as string;
	}

	get clearText(): string {
		return this.$t('shared.actions.clear') as string;
	}

	get tooltipText(): string {
		if (!this.disabled) {
			return '';
		}

		return this.disabledReason ? String(this.disabledReason).trim() : '';
	}

	/** false — способ ant принять файл и не отправлять его: адреса загрузки у компонента нет */
	handleBeforeUpload(file: File): boolean {
		this.$emit('input', file ? file : null);

		return false;
	}

	/** Ранний возврат не дублирует :disabled — обработчик клика на поле остаётся навешенным */
	handleFieldClick(): void {
		if (this.disabled) {
			return;
		}

		const input = this.readNativeInput();

		if (input !== null) {
			input.click();
		}
	}

	handleClear(): void {
		if (this.disabled) {
			return;
		}

		this.clearNativeInput();

		if (this.value != null) {
			this.$emit('input', null);
		}
	}

	reset(): void {
		this.clearNativeInput();

		if (this.value != null) {
			this.$emit('input', null);
		}
	}

	/** Ищем input в своём поддереве: по документу два поля импорта начали бы управлять друг другом */
	private readNativeInput(): HTMLInputElement | null {
		const picker = this.$refs.picker as Vue | undefined;
		const root = picker && picker.$el ? picker.$el : null;

		if (root === null || typeof root.querySelector !== 'function') {
			return null;
		}

		return root.querySelector('input[type="file"]') as HTMLInputElement | null;
	}

	private clearNativeInput(): void {
		const input = this.readNativeInput();

		if (input !== null && input.value !== '') {
			input.value = '';
		}
	}
}
